import { fetchWithBearer } from '@braincube/jwt-browser';

export default function healthCheck(apiName) {
    return fetchWithBearer(`https://${apiName}.${window.BC_API_ENDPOINTS_CONF.base}/braincube-web/ws/v1/healthcheck`);
}
